import { SET_APOLLO_CLIENT } from "../../../constants";

export const setApolloClient = (token: any = []) => ({
  type: SET_APOLLO_CLIENT,
  payload: token,
});
